<template>
  <div>
    <Operator
      :disabled="disabled"
      :operators="operators"
      :value.sync="compareType"/>
  </div>
</template>
<script>
import Operator from 'components/automation/conditions/default/operator.vue'

/**
 * Компонент переключателя
 */
export default {
  name: 'simpleFieldBool',
  computed: {
    compareType: {
      get() {
        if (!this.value?.compareType) {
          return null
        }
        return this.value.compareType
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)
        result.compareType = newValue
        this.$emit('update:value', result)
      }
    },
  },
  components: {
    Operator
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    }
  },
}
</script>
